<template>
  <section class="coupon v-fade">
    <div class="coupon__content">
      <div class="coupon__text-box">
        <h2 v-if="isPercentageDiscount" class="coupon__title">
          You've unlocked
          <span class="coupon__value coupon__value--number">
            {{ billing.switchToAnnualSavings.percent }}%
          </span>
          off your subscription!
        </h2>
        <h2
          v-else-if="isFixedDiscount && !isNewUpgradeToAnnualFixedDiscount"
          class="coupon__title"
        >
          You've unlocked a discount on your subscription!
        </h2>
        <h2 v-else-if="isNewUpgradeToAnnualFixedDiscount" class="coupon__title">
          You've unlocked
          <span class="coupon__value"> 1 month free </span>
          on your subscription!
        </h2>
        <p class="coupon__text">
          {{ billing.billing_plans.discount.prompt }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BillingView } from '@/models/billing'
import { computed } from 'vue'

const props = defineProps<{
  billing: BillingView
}>()

const isPercentageDiscount = computed(() => {
  return props.billing.billing_plans.discount.type_annual === 'percentage'
})

const isFixedDiscount = computed(() => {
  return props.billing.billing_plans.discount.type_annual === 'fixed_amount'
})

// The hardcoded case for the #15680 New User Messaging Journey: Monthly users upsell logic
// (marketing_source.url_slug = new-upgrade-to-annual, coupon: OFF_FLAT_16_42)
const isNewUpgradeToAnnualFixedDiscount = computed(() => {
  return (
    props.billing.billing_plans.discount.type_annual === 'fixed_amount' &&
    props.billing.billing_plans.discount.value_annual === 1642
  )
})
</script>
